/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListResourceAudience } from "../funcs/accessListResourceAudience.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ResourceAudienceResult } from "../models/components/resourceaudienceresult.js";
import {
  ListResourceAudienceRequest,
  ListResourceAudienceSecurity,
  QueryParamResourceKind,
} from "../models/operations/listresourceaudience.js";
import { unwrapAsync } from "../types/fp.js";
export type ResourceAudienceQueryData = ResourceAudienceResult;

export function prefetchResourceAudience(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListResourceAudienceRequest,
  security?: ListResourceAudienceSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildResourceAudienceQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildResourceAudienceQuery(
  client$: GramCore,
  request: ListResourceAudienceRequest,
  security?: ListResourceAudienceSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ResourceAudienceQueryData>;
} {
  return {
    queryKey: queryKeyResourceAudience({
      resourceKind: request.resourceKind,
      resourceId: request.resourceId,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function resourceAudienceQueryFn(
      ctx,
    ): Promise<ResourceAudienceQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListResourceAudience(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyResourceAudience(
  parameters: {
    resourceKind: QueryParamResourceKind;
    resourceId: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listResourceAudience", parameters];
}
